import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICompany } from 'src/app/company/models/company';

@Injectable({
  providedIn: 'root'
})
export class CurrentBasketService {

  constructor() { }

  private _currentCompany$ = new BehaviorSubject<ICompany>(null);
  public currentCompany$ = this._currentCompany$.asObservable();


  public setActiveCompany(company: ICompany){
    this._currentCompany$.next(company);
  }
}
